import { Message, MessageBox } from 'element-ui';
import { checkLoadCarSave, loadCheckElectronic } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';

/**
 * @description 格式化列表数据 -- 数据字典转换, 事件按钮控制
 * @param {*} data
 */
export const formatTotalDataList = (data, dictData) => {
    if (!data.length) return [];
    data.forEach(e => {
        e.taskStatusName = t(e.taskStatus, dictData, 'TRANSPORT_STATUS'); // 类型
        e.arriveTypeName = t(e.arriveType, dictData, 'PICK_UP_TYPE'); // 到车登记方式
    });
    return data;
};

const t = (key, dict, dicType) => {
    if (!key) return '';
    if (!dict[dicType]) {
        Message.warning(`未获取数据字典: ${dicType}`);
        return key;
    };
    return dict[dicType][key];
};

/**
 * @componentsName 按运单/整单装车校验明细数量
*/
export const isValidateLoading = data => {
    return checkLoadCarSave(data).then(res => {
        if (res && +res.code === 0) {
            return !res.data.length ? true : confirm(res.data);
        } else {
            return false;
        }
    });
};
/**
 * @description 装车校验确认框
 */
const confirm = data => {
    let message = '';
    data.forEach(item => {
        message += `<div>${item}</div>`;
    });
    return MessageBox.confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true,
        customClass: 'confirmClass'
    }).then(() => {
        return true;
    }).catch(() => {
        return false;
    });
};

/**
 * @description 装车电子交接校验
 */
export const isValidateElectronic = data => {
    return loadCheckElectronic(data).then(res => {
        if (res && +res.code === 0) {
            return true;
        } else
            return false;
    }).catch(() => {
        return false;
    });
};
